import {Component, input} from '@angular/core';

/**
 * Page heading: optional eyebrow ("Seire"), h1 and subtitle on the left, actions or stats on the right.
 * Slots: `[leading]` (e.g. an avatar), `[after-title]` (next to the h1), default content (below the h1),
 * `[actions]` (right).
 */
@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss',
    host: {
        '[attr.title]': 'null'
    }
})
export class PageHeaderComponent {
    readonly eyebrow = input<string>();
    readonly title = input<string>();
}
